import store from '@/store'
export default [
  {
    path: '/events',
    name: 'event',
    meta: { requiresAuth: true },
    component: () => import('@/pages/event/index.vue')
  },
  {
    path: '/events/:id',
    name: 'event-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/event/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      let response = await store.dispatch('event/find', to.params.id)
      let { ...resource } = response.data
      to.params.editData = resource
      next()
    }
  }
]
